"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[806],{

/***/ 8182:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ card; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4637);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+system@1.11.2_@emotion+react@11.8.1_@emotion+styled@11.8.1_react@17.0.2/node_modules/@chakra-ui/system/dist/chakra-ui-system.esm.js + 3 modules
var chakra_ui_system_esm = __webpack_require__(3879);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+layout@1.7.7_@chakra-ui+system@1.11.2_react@17.0.2/node_modules/@chakra-ui/layout/dist/chakra-ui-layout.esm.js
var chakra_ui_layout_esm = __webpack_require__(9034);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+image@1.1.8_@chakra-ui+system@1.11.2_react@17.0.2/node_modules/@chakra-ui/image/dist/chakra-ui-image.esm.js
var chakra_ui_image_esm = __webpack_require__(7080);
// EXTERNAL MODULE: ./configs/motion-presets.ts + 1 modules
var motion_presets = __webpack_require__(4324);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(9496);
// EXTERNAL MODULE: ./src/components/chakra-ui/framer-motion/index.ts + 2 modules
var framer_motion = __webpack_require__(7994);
;// CONCATENATED MODULE: ./src/utils/react/chakra-element-generator.tsx





function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var createChakraTextsFromArray = function(param) {
    var contents = param.contents, // OPTIONAL
    mb = param.mb, textProps = param.textProps;
    return contents.map(function(content, i) {
        /*#__PURE__*/ return (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, _objectSpread({
            mb: i < contents.length - 1 && mb
        }, textProps, {
            children: content
        }), "text-".concat(i, "-").concat(content.substring(0, 7)));
    });
};
var createChakraTextsFromArrayOrString = function(param) {
    var contents = param.contents, // OPTIONAL
    mb = param.mb, textProps = param.textProps;
    return Array.isArray(contents) ? createChakraTextsFromArray({
        contents: contents,
        mb: mb,
        textProps: textProps
    }) : contents;
};
var createChakraBasicContentsNode = function(param) {
    var content = param.content, // OPTIONAL
    innerWrapProps = param.innerWrapProps, titleProps = param.titleProps, bodyProps = param.bodyProps;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(framer_motion/* MotionBox */.uH, _objectSpread({
        mb: "0"
    }, innerWrapProps, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Heading */.X6, _objectSpread({
                as: "h3",
                mb: "0.5rem",
                textStyle: "content.title-md"
            }, titleProps, {
                children: createChakraTextsFromArrayOrString({
                    contents: content.title,
                    mb: "0.3rem"
                })
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                textStyle: "content.body-md",
                children: createChakraTextsFromArrayOrString({
                    contents: content.body,
                    mb: "0.3rem",
                    // textProps: { textStyle: `content.body-md` },
                    textProps: bodyProps
                })
            })
        ]
    }), content.key);
};
var createChakraBasicContents = function(param) {
    var contents = param.contents, // OPTIONAL
    chakraStyles = param.chakraStyles, wrapProps = param.wrapProps, innerWrapProps = param.innerWrapProps, titleProps = param.titleProps, bodyProps = param.bodyProps;
    var childrenProps = {
        innerWrapProps: innerWrapProps,
        titleProps: titleProps,
        bodyProps: bodyProps
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, _objectSpread({
        __css: chakraStyles
    }, wrapProps, {
        children: Array.isArray(contents) ? contents.map(function(content) {
            return createChakraBasicContentsNode(_objectSpread({
                content: content
            }, childrenProps));
        }) : createChakraBasicContentsNode(_objectSpread({
            content: contents
        }, childrenProps))
    })));
};

;// CONCATENATED MODULE: ./src/utils/react/index.ts


;// CONCATENATED MODULE: ./src/components/chakra-ui/card.tsx




function card_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function card_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            card_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var defaultCardSimpleGridProps = {
    columns: {
        base: 1,
        md: 2
    },
    maxW: {
        base: "500px",
        md: "7xl"
    }
};
var Card = function(param) {
    var _gridProps = param.// OPTIONAL
    gridProps, gridProps = _gridProps === void 0 ? defaultCardSimpleGridProps : _gridProps, _align = param.align, align = _align === void 0 ? "flex-start" : _align, bodyProps = param.bodyProps, _cardWrapProps = param.cardWrapProps, cardWrapProps = _cardWrapProps === void 0 ? {} : _cardWrapProps, contentWrapProps = param.contentWrapProps, contents = param.contents, imgProps = param.imgProps, imgSrc = param.imgSrc, imgWrapProps = param.imgWrapProps, _reverse = param.reverse, reverse = _reverse === void 0 ? false : _reverse, titleProps = param.titleProps, variant = param.variant;
    var styles = (0,chakra_ui_system_esm/* useMultiStyleConfig */.jC)("Card", {
        variant: variant
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Flex */.kC, card_objectSpread({
        justify: "center",
        align: "center"
    }, cardWrapProps, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* SimpleGrid */.MI, {
            dir: reverse && reverse === true ? "rtl" : "ltr",
            columns: gridProps.columns,
            maxW: gridProps.maxW,
            mx: "auto",
            children: [
                imgSrc && /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, card_objectSpread({
                    __css: styles.header
                }, imgWrapProps, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_image_esm/* Image */.Ee, card_objectSpread({
                        __css: styles.header,
                        src: imgSrc,
                        alt: "Card Header Image",
                        w: "full",
                        fit: "cover"
                    }, imgProps))
                })),
                createChakraBasicContents({
                    contents: contents,
                    // OPTIONAL
                    chakraStyles: styles.body,
                    wrapProps: card_objectSpread({
                        alignItems: align,
                        dir: "ltr"
                    }, contentWrapProps),
                    innerWrapProps: card_objectSpread({}, motion_presets/* motionFadeUpProps */.E),
                    titleProps: titleProps,
                    bodyProps: bodyProps
                })
            ]
        })
    })));
};
/* harmony default export */ var card = (Card);

;// CONCATENATED MODULE: ./src/components/chakra-ui/index.ts



/***/ }),

/***/ 2039:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "vr": function() { return /* reexport */ business/* BusinessPageLayout */.vr; },
  "Xg": function() { return /* reexport */ page_layout; }
});

// UNUSED EXPORTS: PageTransition

// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4637);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+system@1.11.2_@emotion+react@11.8.1_@emotion+styled@11.8.1_react@17.0.2/node_modules/@chakra-ui/system/dist/chakra-ui-system.esm.js + 3 modules
var chakra_ui_system_esm = __webpack_require__(3879);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+layout@1.7.7_@chakra-ui+system@1.11.2_react@17.0.2/node_modules/@chakra-ui/layout/dist/chakra-ui-layout.esm.js
var chakra_ui_layout_esm = __webpack_require__(9034);
// EXTERNAL MODULE: ./node_modules/.pnpm/framer-motion@6.2.8_react-dom@17.0.2_react@17.0.2/node_modules/framer-motion/dist/es/value/scroll/use-viewport-scroll.mjs + 1 modules
var use_viewport_scroll = __webpack_require__(5638);
// EXTERNAL MODULE: ./node_modules/.pnpm/framer-motion@6.2.8_react-dom@17.0.2_react@17.0.2/node_modules/framer-motion/dist/es/value/use-transform.mjs + 2 modules
var use_transform = __webpack_require__(1466);
// EXTERNAL MODULE: ./node_modules/.pnpm/framer-motion@6.2.8_react-dom@17.0.2_react@17.0.2/node_modules/framer-motion/dist/es/value/use-spring.mjs
var use_spring = __webpack_require__(1814);
// EXTERNAL MODULE: ./node_modules/.pnpm/framer-motion@6.2.8_react-dom@17.0.2_react@17.0.2/node_modules/framer-motion/dist/es/render/dom/motion.mjs + 129 modules
var motion = __webpack_require__(8593);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/lodash.js
var lodash = __webpack_require__(2699);
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.1.0_@babel+core@7.17.5_react-dom@17.0.2_react@17.0.2_sass@1.49.9/node_modules/next/script.js
var script = __webpack_require__(9029);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(9496);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-use@17.3.2_react-dom@17.0.2_react@17.0.2/node_modules/react-use/esm/useLockBodyScroll.js
var useLockBodyScroll = __webpack_require__(4740);
// EXTERNAL MODULE: ./configs/index.ts + 5 modules
var configs = __webpack_require__(9457);
// EXTERNAL MODULE: ./src/components/index.ts + 4 modules
var components = __webpack_require__(3890);
// EXTERNAL MODULE: ./src/layout/index.ts + 16 modules
var layout = __webpack_require__(7818);
// EXTERNAL MODULE: ./src/utils/index.ts + 10 modules
var utils = __webpack_require__(7925);
;// CONCATENATED MODULE: ./src/layouts/page-layout.tsx











function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var PageLayout = function(param) {
    var children = param.children, nextPageHref = param.nextPageHref, // OPTIONAL
    headerProps = param.headerProps, _lockScroll = param.lockScroll, lockScroll = _lockScroll === void 0 ? false : _lockScroll, _mainProps = param.mainProps, mainProps = _mainProps === void 0 ? {} : _mainProps, _marginTopForHeader = param.marginTopForHeader, marginTopForHeader = _marginTopForHeader === void 0 ? false : _marginTopForHeader, seoProps = param.seoProps, _showNextPageButton = param.showNextPageButton, showNextPageButton = _showNextPageButton === void 0 ? false : _showNextPageButton;
    var mt = marginTopForHeader && {
        base: "76px",
        md: "76px"
    };
    if (!lodash_default().has(mainProps, "mt")) mainProps.mt = mt;
    (0,useLockBodyScroll/* default */.Z)(lockScroll);
    var ref = _slicedToArray((0,utils/* useStateL */.Fs)(false, "isComplete"), 2), isComplete = ref[0], setIsComplete = ref[1];
    var scrollYProgress = (0,use_viewport_scroll/* useViewportScroll */.M)().scrollYProgress;
    var yRange = (0,use_transform/* useTransform */.H)(scrollYProgress, [
        0,
        0.9
    ], [
        0,
        1
    ]);
    var pathLength = (0,use_spring/* useSpring */.q)(yRange, {
        stiffness: 400,
        damping: 90
    });
    (0,react.useEffect)(function() {
        ;
    }, [
        scrollYProgress
    ]);
    (0,react.useEffect)(function() {
        return yRange.onChange(function(v) {
            return setIsComplete(v >= 1);
        });
    }, [
        setIsComplete,
        yRange
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* SEO */.HJ, _objectSpread({}, seoProps)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* Header */.h4, _objectSpread({}, headerProps)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_system_esm/* chakra.main */.m$.main, _objectSpread({
                overflow: "hidden"
            }, mainProps, {
                children: children
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* NextPageButton */.kq, {
                /* show={showNextPageButton} */ show: false,
                href: nextPageHref
            }),
            configs/* __DEV__ */.Ts && /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                position: "fixed",
                top: "100px",
                left: "20px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                    className: "progress-icon",
                    style: {
                        width: "120px",
                        height: "120px"
                    },
                    viewBox: "0 0 60 60",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.path */.E.path, {
                            fill: "none",
                            strokeWidth: "5",
                            stroke: "#ccc",
                            strokeDasharray: "0px 10000px",
                            d: "M 0, 20 a 20, 20 0 1,0 40,0 a 20, 20 0 1,0 -40,0",
                            style: {
                                pathLength: pathLength,
                                rotate: 90,
                                translateX: 5,
                                translateY: 5,
                                scaleX: -1
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.path */.E.path, {
                            fill: "none",
                            strokeWidth: "5",
                            stroke: "#eee",
                            d: "M14,26 L 22,33 L 35,16",
                            initial: false,
                            strokeDasharray: "0px 10000px",
                            animate: {
                                pathLength: isComplete ? 1 : 0
                            }
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(script["default"], {
                id: "google-analytics-global-load",
                children: "\n          (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n          })(window,document,'script','dataLayer','GTM-MCWHHBXZ');\n        "
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("noscript", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                    src: "https://www.googletagmanager.com/ns.html?id=GTM-MCWHHBXZ",
                    height: "0",
                    width: "0",
                    // style="display:none;visibility:hidden"
                    style: {
                        display: "none",
                        visibility: "hidden"
                    }
                })
            })
        ]
    }));
};
/* harmony default export */ var page_layout = (PageLayout);

// EXTERNAL MODULE: ./src/components/chakra-ui/framer-motion/motion-main.tsx
var motion_main = __webpack_require__(6279);
;// CONCATENATED MODULE: ./src/layouts/page-transition.tsx



function page_transition_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function page_transition_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            page_transition_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var motionVariants = {
    hidden: {
        opacity: 0,
        x: 0,
        y: 0
    },
    enter: {
        opacity: 1,
        x: 0,
        y: 0
    },
    exit: {
        opacity: 0,
        x: 0,
        y: 0
    }
};
var PageTransition = function(param) {
    var key = param.key, children = param.children, // OPTIONAL
    mainProps = param.mainProps;
    return(/*#__PURE__*/ _jsx(MotionMain, page_transition_objectSpread({
        overflow: "hidden"
    }, mainProps, {
        initial: "hidden",
        animate: "enter",
        exit: "exit",
        variants: motionVariants,
        transition: {
            type: "linear",
            duration: 0.2
        },
        children: children
    }), key));
};
/* harmony default export */ var page_transition = ((/* unused pure expression or super */ null && (PageTransition)));

// EXTERNAL MODULE: ./src/layouts/pages/business/index.ts + 5 modules
var business = __webpack_require__(6291);
;// CONCATENATED MODULE: ./src/layouts/index.ts





/***/ }),

/***/ 6291:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "qv": function() { return /* reexport */ about_section_layout; },
  "vr": function() { return /* reexport */ business_BusinessPageLayout; },
  "Qc": function() { return /* reexport */ process_section_layout; },
  "Ts": function() { return /* reexport */ specialty_section_layout; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4637);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+media-query@2.0.4_@chakra-ui+system@1.11.2_@chakra-ui+theme@1.14.0_react@17.0.2/node_modules/@chakra-ui/media-query/dist/chakra-ui-media-query.esm.js
var chakra_ui_media_query_esm = __webpack_require__(6798);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+layout@1.7.7_@chakra-ui+system@1.11.2_react@17.0.2/node_modules/@chakra-ui/layout/dist/chakra-ui-layout.esm.js
var chakra_ui_layout_esm = __webpack_require__(9034);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(9496);
// EXTERNAL MODULE: ./src/components/chakra-ui/index.ts + 3 modules
var chakra_ui = __webpack_require__(8182);
// EXTERNAL MODULE: ./src/layout/index.ts + 16 modules
var layout = __webpack_require__(7818);
// EXTERNAL MODULE: ./src/utils/index.ts + 10 modules
var utils = __webpack_require__(7925);
;// CONCATENATED MODULE: ./src/layouts/pages/business/about-section-layout.tsx






function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var AboutSectionLayout = function(param) {
    var name = param.name, title = param.title, card1Props = param.card1Props, // OPTIONAL
    card2Props = param.card2Props, _description = param.description, description = _description === void 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            (0,utils.t)("pages.business.common.sections.about.description1"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* ResponsiveBr */.e5, {
                breakpoint: "md"
            }),
            (0,utils.t)("pages.business.common.sections.about.description2")
        ]
    }) : _description;
    var variant = (0,chakra_ui_media_query_esm/* useBreakpointValue */.Sx)({
        base: "rounded",
        md: "flat"
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* GeneralSection */.d, {
        name: name,
        disableAnimation: true,
        description: description,
        pbMult: 1.5,
        sectionSize: layout/* SectionSize.SM */.f3.SM,
        title: title,
        titleProps: {
            fontSize: {
                base: "1.8rem",
                md: "2.7rem"
            }
        },
        titleWrapProps: {
            mb: {
                base: "2.75rem",
                md: "5rem"
            },
            mt: {
                md: "0.75rem"
            }
        },
        children: variant && /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Stack */.Kq, {
            spacing: {
                base: "4rem",
                md: 0
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui/* Card */.Z, _objectSpread({}, card1Props, {
                    variant: variant
                })),
                card2Props ? /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui/* Card */.Z, _objectSpread({}, card2Props, {
                    variant: variant,
                    reverse: variant === "flat"
                })) : null
            ]
        })
    }));
};
/* harmony default export */ var about_section_layout = (AboutSectionLayout);

// EXTERNAL MODULE: ./src/layouts/index.ts + 2 modules
var layouts = __webpack_require__(2039);
// EXTERNAL MODULE: ./src/views/common/sections/index.ts + 1 modules
var sections = __webpack_require__(3916);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+system@1.11.2_@emotion+react@11.8.1_@emotion+styled@11.8.1_react@17.0.2/node_modules/@chakra-ui/system/dist/chakra-ui-system.esm.js + 3 modules
var chakra_ui_system_esm = __webpack_require__(3879);
// EXTERNAL MODULE: ./src/layout/header/index.ts + 6 modules
var header = __webpack_require__(109);
// EXTERNAL MODULE: ./src/layout/section.tsx
var section = __webpack_require__(2179);
;// CONCATENATED MODULE: ./src/layouts/pages/business/BannerSection.tsx







function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var log = (0,utils/* createLog */.xN)("BannerSection");
var BannerSection = function(param) {
    var curPageIdx = param.curPageIdx, _isActive = param.// OPTIONAL
    isActive, isActive = _isActive === void 0 ? true : _isActive;
    var isMobile = (0,utils/* useGridProps */.by)().isMobile;
    var ref = _slicedToArray((0,utils/* useStateL */.Fs)(false, "isVLOpen"), 2), _isVLOpen = ref[0], toggleVL = ref[1];
    // isActive
    (0,react.useEffect)(function() {
        log.debug("isActive: ".concat(isActive));
    }, [
        isActive
    ]);
    (0,react.useEffect)(function() {
        var timeout = setTimeout(function() {
            if (isActive) {
                toggleVL(true);
            }
        }, 500);
        return function() {
            return clearTimeout(timeout);
        };
    }, [
        isActive,
        toggleVL
    ]);
    var createBottomNavbar = function() {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_system_esm/* chakra.header */.m$.header, {
            shadow: "md",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Flex */.kC, {
                align: "center",
                color: "gray.400",
                justify: "space-around",
                maxW: "1100px",
                mx: "auto",
                mb: "4px",
                py: "1.75rem",
                w: "100%",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* HStack */.Ug, {
                    color: "blackAlpha.800",
                    display: {
                        base: "none",
                        md: "flex"
                    },
                    divider: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* StackDivider */.cX, {
                        borderColor: "gray.300"
                    }),
                    fontSize: {
                        base: "1rem",
                        md: "1.2rem"
                    },
                    fontWeight: "600",
                    spacing: "5rem",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(header/* NavLink */.O, {
                            href: "/business/viral",
                            name: "바이럴 마케팅"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(header/* NavLink */.O, {
                            href: "/business/media",
                            name: "언론 송출"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(header/* NavLink */.O, {
                            href: "/business/searchad",
                            name: "검색 광고"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(header/* NavLink */.O, {
                            href: "/business/marketing",
                            name: "종합 마케팅"
                        })
                    ]
                })
            })
        }));
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(layout/* GeneralSection */.d, {
        name: "banner",
        // OPTIONAL
        px: "0",
        sectionSize: section/* SectionSize.FIT */.f3.FIT,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Flex */.kC, {
                py: "0",
                flexDir: "column",
                align: "center",
                justify: "flex-end",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Flex */.kC, {
                    align: "center",
                    bg: "linear-gradient(0deg, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.1)), url(/pages/business/banner_bg.webp)",
                    bgAttachment: "fixed",
                    bgPos: {
                        base: "55% 76px",
                        md: "0 0"
                    },
                    bgRepeat: "no-repeat",
                    bgSize: {
                        base: "300%",
                        md: "105%"
                    },
                    flexDir: "column",
                    fontSize: {
                        base: "1.15rem",
                        md: "1.5rem"
                    },
                    fontWeight: "600",
                    h: {
                        base: "28vh",
                        md: "30vh"
                    },
                    justify: "center",
                    textShadow: "0 0 3px rgba(0, 0, 0, 0.45)",
                    w: "100%",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                            as: "p",
                            children: "더 나은 마케팅을 위해 고민합니다."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                            as: "p",
                            children: "경험을 통해 새로운 가치를 만들어냅니다."
                        })
                    ]
                })
            }),
            !isMobile && createBottomNavbar()
        ]
    }));
};
/* harmony default export */ var business_BannerSection = (BannerSection);

;// CONCATENATED MODULE: ./src/layouts/pages/business/BusinessPageLayout.tsx







function BusinessPageLayout_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function BusinessPageLayout_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function BusinessPageLayout_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function BusinessPageLayout_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function BusinessPageLayout_slicedToArray(arr, i) {
    return BusinessPageLayout_arrayWithHoles(arr) || BusinessPageLayout_iterableToArrayLimit(arr, i) || BusinessPageLayout_unsupportedIterableToArray(arr, i) || BusinessPageLayout_nonIterableRest();
}
function BusinessPageLayout_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return BusinessPageLayout_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return BusinessPageLayout_arrayLikeToArray(o, minLen);
}
var UNIT_NAME = "BusinessPageLayout";
var BusinessPageLayout = function(param) {
    var children = param.children, curPageIdx = param.curPageIdx, nextPageHref = param.nextPageHref;
    var log = (0,utils/* useLog */.Tx)(UNIT_NAME);
    var ref = BusinessPageLayout_slicedToArray((0,utils/* useStateL */.Fs)(false, "showNextPageButton"), 2), showNextPageButton = ref[0], setShowNextPageButton = ref[1];
    var handleContactSectionInView = (0,react.useCallback)(function(inView, entry) {
        log.debug("inView: ".concat(inView, ", inViewEntry: ").concat(JSON.stringify(entry)));
        setShowNextPageButton(inView);
    }, [
        log,
        setShowNextPageButton
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(layouts/* PageLayout */.Xg, {
        marginTopForHeader: true,
        nextPageHref: nextPageHref,
        seoProps: {
            title: (0,utils.t)("pages.about.seo.title"),
            description: (0,utils.t)("pages.about.seo.description")
        },
        // TODO: pageTransition
        // showFloatingButtons
        showNextPageButton: showNextPageButton,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(business_BannerSection, {
                curPageIdx: curPageIdx,
                // OPTIONAL
                isActive: true
            }),
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sections/* ContactSection */.U, {
                handleInView: handleContactSectionInView
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* Footer */.$_, {})
        ]
    }));
};
/* harmony default export */ var business_BusinessPageLayout = (BusinessPageLayout);

;// CONCATENATED MODULE: ./src/layouts/pages/business/process-section-layout.tsx




var ProcessSectionLayout = function(param) {
    var children = param.children;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* GeneralSection */.d, {
        name: "process",
        bgImg: "/pages/business/viral/sections/process/bg.png",
        bgFixed: true,
        description: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "왜 이노앤엠이어야 하는지",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {
                    className: "md"
                }),
                "차별화된 서비스를 보여드리겠습니다"
            ]
        }),
        sectionType: layout/* SectionType.DARK */.bA.DARK,
        title: "PROCESS",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Grid */.rj, {
            templateColumns: {
                base: "repeat(2, 1fr)",
                md: "repeat(4, 1fr)"
            },
            gap: {
                base: "2rem",
                md: "2.5rem"
            },
            pt: "2rem",
            px: {
                md: "3rem"
            },
            children: children
        })
    }));
};
/* harmony default export */ var process_section_layout = (ProcessSectionLayout);

;// CONCATENATED MODULE: ./src/layouts/pages/business/specialty-section-layout.tsx




var SpecialtySectionLayout = function(param) {
    var children = param.children;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(layout/* GeneralSection */.d, {
        name: "specialty",
        sectionType: layout/* SectionType.LIGHT */.bA.LIGHT,
        title: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_system_esm/* chakra.h2 */.m$.h2, {
            textStyle: "heading",
            mb: "5",
            fontSize: {
                base: "2.2rem",
                md: "2.7rem"
            },
            children: [
                "이노앤엠만의",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                    as: "span",
                    color: "brand.300",
                    children: "특별함"
                })
            ]
        }),
        titleTextUnderlineDividerProps: {
            show: false
        },
        titleWrapProps: {
            mb: {
                base: "2rem",
                md: "3rem"
            }
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Flex */.kC, {
            flexDir: {
                base: "column",
                md: "row"
            },
            gap: {
                base: "5rem",
                md: "0"
            },
            children: children
        })
    });
};
/* harmony default export */ var specialty_section_layout = (SpecialtySectionLayout);

;// CONCATENATED MODULE: ./src/layouts/pages/business/index.ts






/***/ }),

/***/ 3916:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "U": function() { return /* reexport */ contact; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4637);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+layout@1.7.7_@chakra-ui+system@1.11.2_react@17.0.2/node_modules/@chakra-ui/layout/dist/chakra-ui-layout.esm.js
var chakra_ui_layout_esm = __webpack_require__(9034);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(9496);
// EXTERNAL MODULE: ./src/layout/index.ts + 16 modules
var layout = __webpack_require__(7818);
;// CONCATENATED MODULE: ./src/views/common/sections/contact.tsx




function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var ContactSection = function(param) {
    var // OPTIONAL
    handleInView = param.handleInView, sectionProps = param.sectionProps;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(layout/* GeneralSection */.d, _objectSpread({
        name: "contact",
        // OPTIONAL
        bgImg: "/pages/business/bg_contact.png",
        handleInView: handleInView,
        sectionSize: layout/* SectionSize.XL */.f3.XL
    }, sectionProps, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Flex */.kC, {
            flexDir: "column",
            align: "center",
            justify: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Text */.xv, {
                    color: "white",
                    fontSize: {
                        base: "1.2rem",
                        md: "1.6rem"
                    },
                    fontWeight: "600",
                    mb: "2.5rem",
                    textAlign: "center",
                    textShadow: "0 0 1.5px #fff",
                    children: [
                        "함께 성장하는 기쁨, ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* ResponsiveBr */.e5, {
                            breakpoint: "md"
                        }),
                        "이노앤엠과 함께하고 싶으신가요?"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                    border: "3px solid blue",
                    borderColor: "brand.400",
                    borderRadius: "2.5rem",
                    color: "brand.400",
                    fontSize: {
                        base: "1.2rem",
                        md: "1.6rem"
                    },
                    fontWeight: "600",
                    p: "0.75rem 2.75rem",
                    _hover: {
                        bgColor: "brand.400",
                        color: "white"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Link */.rU, {
                        href: "/contact",
                        _hover: {
                            textDecor: "none"
                        },
                        children: "CONTACT 바로가기"
                    })
                })
            ]
        })
    }));
};
/* harmony default export */ var contact = (ContactSection);

;// CONCATENATED MODULE: ./src/views/common/sections/index.ts



/***/ })

}]);